import React from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import Select from "react-select";
import moment from "moment";
import { convertPeriodToDate } from "../../utils";

const periodOptions = [
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "last_7_days", label: "Last 7 Days" },
  { value: "last_15_days", label: "Last 15 Days" },
  { value: "last_30_days", label: "Last 30 Days" },
  { value: "this_month", label: "This Month" },
  { value: "last_month", label: "Last Month" },
  { value: "last_3_months", label: "Last 3 Months" },
  { value: "this_year", label: "This Year (YTD)" },
  { value: "custom", label: "Custom Range" },
];

const CustomDateRangePicker = ({
  fromDate,
  toDate,
  selectedPeriod,
  onChange,
  lablePosition = "horizontal",
  isClearable = false,
}) => {
  const updateAndNotify = (from, to, period) => {
    if (onChange) {
      onChange({ fromDate: from, toDate: to, selectedPeriod: period });
    }
  };

  const applyPresetPeriod = (option) => {
    if (option?.value && option.value !== "custom") {
      const { from, to } = convertPeriodToDate(option.value);
      updateAndNotify(from, to, option);
    }
  };

  const handleSelectChange = (option) => {
    if (!option?.value) {
      updateAndNotify("", "", null);
    } else if (option.value === "custom") {
      const from = fromDate || moment().format("YYYY-MM-DD");
      const to = toDate || moment().format("YYYY-MM-DD");
      updateAndNotify(from, to, option);
    } else {
      applyPresetPeriod(option);
    }
  };

  const onCustomRangeApply = (start, end) => {
    const from = start.format("YYYY-MM-DD");
    const to = end.format("YYYY-MM-DD");
    updateAndNotify(from, to, { value: "custom", label: "Custom Range" });
  };

  return (
    <div className="d-flex align-items-center gap-4">
      <div
        className={`d-flex ${
          lablePosition === "horizontal"
            ? "flex-column"
            : "flex-row gap-2 align-items-center"
        }`}
      >
        <strong>Select Period</strong>
        <Select
          id="period_filter"
          className="react-select"
          classNamePrefix="select"
          placeholder={"Select Period"}
          options={periodOptions}
          isClearable={isClearable}
          value={selectedPeriod}
          onChange={handleSelectChange}
        />
      </div>

      {selectedPeriod?.value === "custom" && (
        <div
          className={`d-flex ${
            lablePosition === "horizontal"
              ? "flex-column"
              : "flex-row gap-2 align-items-center"
          }`}
        >
          <strong>Custom Range</strong>
          <DateRangePicker
            initialSettings={{
              startDate: fromDate,
              endDate: toDate,
              locale: {
                format: "YYYY-MM-DD",
              },
            }}
            onCallback={onCustomRangeApply}
          >
            <input
              type="text"
              name="date"
              className="form-control input-daterange-timepicker"
              readOnly
              value={
                fromDate && toDate ? `${fromDate} - ${toDate}` : ""
              }
            />
          </DateRangePicker>
        </div>
      )}
    </div>
  );
};

export default CustomDateRangePicker;
